export default "__VITE_ASSET__D2U_J89y__"